export const documentOptions = [
  { value: '020', label: 'Báo cáo' },
  { value: '021', label: 'Công văn' },
  { value: '022', label: 'Quyết định' },
  { value: '023', label: 'Thông báo / Giấy mời' },
  { value: '024', label: 'Tờ trình' },
  { value: '025', label: 'Khác' },
  { value: '026', label: 'Quy định' },
  { value: '027', label: 'Phương án' },
  { value: '028', label: 'Đề án' },
  { value: '029', label: 'Quy chế' },
  { value: '030', label: 'Hướng dẫn' },
  { value: '031', label: 'Thông báo' },
  { value: '032', label: 'Kế hoạch' },
  { value: '033', label: 'Hợp đồng' },
  { value: '034', label: 'Biên bản' },
  { value: '035', label: 'Giấy ủy quyền' },
  { value: '036', label: 'Giấy giới thiệu' },
]
